import type { ReactNode } from 'react'
import css from '../../Sidebar.module.css'

interface SidebarButtonsWrapperProps {
    children: ReactNode
    position?: 'top' | 'bottom'
    className?: string
}

const SidebarButtonsWrapper = ({ children, position, className: customClassName }: SidebarButtonsWrapperProps) => {
    const className = [
        css.sidebar_buttons_wrapper,
        position === 'bottom' && css.sidebar_buttons_wrapper_bottom,
        customClassName
    ].filter(Boolean).join(' ')

    return (
        <div className={className}>
            {children}
        </div>
    )
}

export default SidebarButtonsWrapper
